<template>
  <preloader></preloader>
  <div class="main-wrapper" @click="closeModal">
    <left-menu></left-menu>
    <router-view></router-view>
    <vue-widget v-if="Object.keys(profile).length"
      domain="https://help.ttc.kz" 
      :lang="lang === 'kz' ? 'kk' : lang" 
      :first-name="profile.first_name"
      :last-name="profile.last_name"
      :patronymic="profile.patronymic"
      :phone-number="profile.phone"
      :email="profile.email"
     ></vue-widget>
    <right-menu></right-menu>
    <div v-show="showNotification" style="display: flex; gap: 10px; padding: 30px; color: #fff; z-index:9999999; font-size: 14px; position: fixed; bottom: 0; left: 0; width: 100%; background-color: rgba(0,0,0,.85)">
        <div style="flex: 1">
          {{ $t("notificationPart") }}<a style="font-size: 14px; text-decoration: underline; color: #fff" :href='$t("confdoc")'>{{ $t("notificationPart2") }}</a>.
        </div>
        <button @click="closeNotification" style="padding: 10px 30px; border: none; background-color: #cb2323; color: #fff; border-radius: 5px; cursor: pointer;">{{ $t("agreeBtn") }}</button>
    </div>
  </div>
  <modals></modals>
  <icons></icons>
</template>

<script>
import Preloader from "@/components/Preloader";
import LeftMenu from "@/components/LeftMenu";
import RightMenu from "@/components/RightMenu";
import Modals from "@/components/Modals";
import Icons from "@/components/Icons";
import { mapMutations, mapGetters } from 'vuex'


export default {
  components: {
    Preloader,
    LeftMenu,
    RightMenu,
    Icons,
    Modals
  },
  data() {
    return {
      showNotification: true
    }
  },
  computed: {
    ...mapGetters({
      lang: 'assistant/lang',
      profile: 'profile/profileData',
    }),
  },
  methods: {
    ...mapMutations({
      setUserData: 'authorization/authSuccess',
      setAssistantType: 'assistant/setAssistantType'
    }),
    closeAssistant() {
      const bodyElem = document.querySelector('body')
      if (!window.matchMedia("(min-width: 1px) and (max-width: 1199px)").matches) {
        bodyElem.classList.contains('assistant-hide') || bodyElem.classList.add("assistant-hide")
      } 
      this.setAssistantType('assistant-profile')
    },
    closeNav() {
      const bodyElem = document.querySelector('body')
      if (!window.matchMedia("(min-width: 1px) and (max-width: 1199px)").matches) {
        bodyElem.classList.contains('menu-hide') || bodyElem.classList.add("menu-hide")
      }

    },
    closeNotification(){
        this.showNotification = false
    },
    closeModal($event) {
      if(!$event.target.closest('.assistant')){
        this.closeAssistant()
      }
      if(!$event.target.closest('.menu')){
        this.closeNav()
      }
    }
  },
  created() {
    this.setUserData()
  },
}
</script>

<style>

</style>
